import { Config } from "./config";
import { ISignalRService } from "./interfaces/ISignalR";

const environmentSpecificAPIUrl =
  process.env.VUE_APP_ENV_MyURL || Config.api_url;

const TYPES = {
  ISignalRService: Symbol.for("ISignalRService"),
  IEmploymentService: Symbol.for("IEmploymentService"),
  IJobPositionResource: Symbol.for("IJobPositionResource"),
  IContainerResource: Symbol.for("IContainerResource"),
  IEmploymentHttpClient: Symbol.for("IEmploymentHttpClient"),
  IBillingService: Symbol.for("IBillingService"),
  IOdinAdminService: Symbol.for("IOdinAdminService"),
  APIService: Symbol.for("APIService"),
  BaseURL: environmentSpecificAPIUrl,
};

export { TYPES };
